import { Alert, Button, ColorSwatch, Group, Stack, Text } from "@mantine/core";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { useRepoLabels } from "./useLabelMappings";

// Блок «Импорт меток репозитория» секции «Семантика меток».
//
// Метки репо со swatch'ами цвета; неотмапленные (нет в `mappedNames`)
// подсвечены. `LabelMappingSection` монтирует блок при выбранном
// репозитории и включённом модуле `task_tracker`.
export interface RepoLabelsImportProps {
  readonly repo: string;
  readonly mappedNames: ReadonlySet<string>;
}

export function RepoLabelsImport({
  repo,
  mappedNames,
}: RepoLabelsImportProps): ReactElement {
  const { t } = useTranslation();
  const labelsQuery = useRepoLabels(repo);

  return (
    <Stack gap="xs">
      <Group justify="space-between">
        <Text fw={500}>{t("connections.labelMapping.importTitle")}</Text>
        <Button
          size="xs"
          variant="default"
          onClick={() => {
            void labelsQuery.refetch();
          }}
          loading={labelsQuery.isFetching}
        >
          {t("connections.labelMapping.importButton")}
        </Button>
      </Group>
      {labelsQuery.isError ? (
        <Alert color="red" title={t("connections.errorHeading")}>
          {t("connections.labelMapping.importError")}
        </Alert>
      ) : labelsQuery.data !== undefined ? (
        labelsQuery.data.labels.length === 0 ? (
          <Text c="dimmed" size="sm">
            {t("connections.labelMapping.importEmpty")}
          </Text>
        ) : (
          <Group gap="xs">
            {labelsQuery.data.labels.map((label) => (
              <Group key={label.name} gap={4}>
                <ColorSwatch color={`#${label.color}`} size={14} />
                <Text
                  size="sm"
                  {...(mappedNames.has(label.name) ? {} : { c: "orange" })}
                >
                  {label.name}
                </Text>
              </Group>
            ))}
          </Group>
        )
      ) : null}
    </Stack>
  );
}
